import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AbstractBasicSignalInput } from '../../abstract-basic-signal-input.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-ui-radio-button',
  imports: [NgTemplateOutlet],
  templateUrl: './radio-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent<T extends string> extends AbstractBasicSignalInput<T> {
  readonly radioButtonValue = input.required<T>();

  readonly checked = computed(() => this.radioButtonValue() === this.value());
}
